module.exports = __webpack_public_path__ + "static/media/purchaseIconDisabled.656354ae.svg";